// import Application_Details from "@/components/ui/application_details";
//import BreadCrumb from "@/components/ui/breadcrumb/breadcrumb";
//import Details_Slider from "@/components/ui/details_slider";
import Product_Details from "@/components/ui/product_details";
import { generateBreadcrumbSchema } from "@/utils/constants";
// import Related_Products from "@/components/ui/related_products";
import dynamic from "next/dynamic";
import Head from "next/head";
import { useSelector } from "react-redux";
const Application_Details = dynamic(
  () => import("@/components/ui/application_details"),
  { ssr: true }
);
const BreadCrumb = dynamic(
  () => import("@/components/ui/breadcrumb/breadcrumb"),
  { ssr: true }
);
const Details_Slider = dynamic(() => import("@/components/ui/details_slider"), {
  ssr: true,
});

const Related_Products = dynamic(
  () => import("@/components/ui/related_products"),
  { ssr: true }
);

const Bathware_Details_Page = ({ bathwareProductDetailsUrl, bathwareProductDetailsApiData, currentUrl }) => {
  // const bathwareProductDetailsApiData = useSelector(
  //   (state) => state.bathwareProductDetailsData
  // );
  const bannerData = bathwareProductDetailsApiData?.images || [];
  const applicationDetails = bathwareProductDetailsApiData?.applications || {};
  const relatedProducts = bathwareProductDetailsApiData?.related_products || [];
  const FAQ_Data = bathwareProductDetailsApiData?.faqs || [];
  const beforeFooterSection =
    bathwareProductDetailsApiData?.before_footer || {};
  // Transformation productDetails data
  const productDetails = [
    {
      heading: bathwareProductDetailsApiData.product_name,
      description: bathwareProductDetailsApiData.description,
      categoryList: [
        {
          category: bathwareProductDetailsApiData.category,
          code: bathwareProductDetailsApiData.product_code
            ?.split(", ")
            .map((dist) => dist.trim()),
          sizes: bathwareProductDetailsApiData.sizes
            ?.split(", ")
            .map((dist) => dist.trim()),
          features: bathwareProductDetailsApiData.features
            ?.split(", ")
            .map((dist) => dist.trim()),
          trapDist: bathwareProductDetailsApiData.trap_distance
            ?.split(", ")
            .map((dist) => dist.trim()),
        },
      ],
      deg_360: true, // Setting as true since it's a default value
    },
  ];

  const breadcrumbData = [
    {
      title: "Bathware",
      link: "/bathware",
    },
    {
      title: bathwareProductDetailsApiData.product_name,
    },
  ];

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateBreadcrumbSchema(breadcrumbData, currentUrl)
            ),
          }}
        />
      </Head>
      <section>
        <div className="py-5 lg:py-[2vw]">
          <BreadCrumb
            breadcrumbData={breadcrumbData}
            customClass={"sm:!relative sm:!bottom-0"}
          />
        </div>

        <div className="lg:flex lg:flex-wrap container justify-between">
          <div className="lg:w-[55%] mb-5 lg:mb-0">
            <Details_Slider productData={bannerData} heading={productDetails?.[0]?.heading} />
          </div>

          <div className="lg:w-[42%]">
            <Product_Details
              heading={productDetails?.[0]?.heading}
              description={productDetails?.[0]?.description}
              deg_360={productDetails?.[0]?.deg_360}
              categoryList={productDetails?.[0]?.categoryList}
              bathwareProductDetailsApiData={bathwareProductDetailsApiData}
              bathwareProductDetailsUrl={bathwareProductDetailsUrl}
            />
          </div>
        </div>
      </section>

      <section>
        <div className="container">
          <Application_Details
            centerClass={"text-center"}
            applicationDetails={applicationDetails}
          />
        </div>
      </section>

      {/* <Link_Button_Sec productDetails={bathwareProductDetailsApiData} />

      <Product_Drawing productDrawingDetails={bathwareProductDetailsApiData} /> */}

      <Related_Products relatedProducts={relatedProducts} />
      {/* {FAQ_Data.length > 0 && <FAQ FAQ_Data={F
      AQ_Data} />} */}

      {/* {Object.keys(beforeFooterSection).length > 0 && (
        <Dummy_Sec beforeFooterSection={beforeFooterSection} />
      )
      } */}
    </>
  );
};

export default Bathware_Details_Page;
